import { getUser } from '@/filters/user'
import { IUsuarioIsolve } from '@/interfaces'
import { VueComponent } from '@/vue-ts-component'
import Vue from 'vue'
import Component from 'vue-class-component'
import { VSkeletonLoader } from 'vuetify/lib'

const AppUserProps = Vue.extend({
	props: {
		userId: Number
	}
})

@Component({})
export class AppUser extends AppUserProps {
	isLoading = true
	user: IUsuarioIsolve | undefined

	render() {
		return (
			<VSkeletonLoader loading={this.isLoading} type="list-item">
				<span>{this.user?.nome}</span>
			</VSkeletonLoader>
		)
	}

	mounted() {
		this.getUserData()
	}
	async getUserData() {
		this.isLoading = true
		this.user = await getUser(this.userId)
		this.isLoading = false
	}
}

export default AppUser
